import { colors } from '../../colors';
var threeTile = {
  borderColor: colors.overcast,
  headingColor: colors.white,
  paraColor: colors.white,
  subHeadingColor: colors.white,
  bgColor: colors.duskBlue,
  ctaColor: colors.rust,
  textColorDark: colors.graphite,
  textColorLight: colors.white,
  cardBgColorVariationC: colors.white
};
export default threeTile;